const zh_TW = {
  'android': `Android`,
  'contact_us': `與我們聯絡`,
  'cookie_accept_all': `同意所有Cookie`,
  'cookie_accept_selected': `確認`,
  'cookie_learn_more': `瞭解更多`,
  'cookie_settings': `Cookie 設定`,
  'cookie_settings_desc': `本網站使用cookies以提供所需的網站功能、流量分析、社群媒體功能、以及更優質與個人化的訊息。我們的cookie 聲明提供更詳細資訊及如何調整目前cookie設定`,
  'cookie_toggle_required': `必要Cookie`,
  'cookie_toggle_required_desc': `網站運作時離不開這些Cookie且您不能在系統中將其關閉。通常僅根據您所做出的操作(即服務請求)來設定這些Cookie，如設定隱私偏好、登入或填寫表格。您可以將您的瀏覽器設定為阻止或向您提示的這些Cookie，但可能會導致某些網站功能無法作業。`,
  'cookie_toggle_performance': `成效Cookie`,
  'cookie_toggle_performance_desc': `使用 Cookie，我們可以計算瀏覽量及流量來源，以利檢視及提高我們網站的使用者體驗。Cookie 有助於我們了解哪些頁面最受歡迎、哪些最不受歡迎，並了解訪問者如何瀏覽網站。這些Cookie收集的所有訊息都集合在一起以匿名的方式處理。如果您不允許使用這些Cookie，我們將不知道您何時瀏覽我們的網站。`,
  'copyright_statement': `版權所有© 2023 Trend Micro Incorporated / 趨勢科技股份有限公司。保留所有權利。`,
  'device_detail': `裝置詳細資訊`,
  'expired_on': `到期日：`,
  'expires_on': `到期日：`,
  'help_center': `說明中心`,
  'ios': `iOS`,
  'label_alarm': `警報`,
  'label_locate': `定位`,
  'label_lock': `鎖定`,
  'label_lost_device_protection': `行動裝置失竊防護`,
  'label_reset': `重設`,
  'label_trend_micro': `趨勢科技`,
  'label_wipe': `清除`,
  'landing_page_android_only': `僅 Android`,
  'landing_page_description': `輕鬆尋找、鎖定或清除遺失行動裝置中的資料。`,
  'landing_page_description_main_function': `防止裝置遺失、資料遭竊等等。`,
  'landing_page_download_from': `趨勢科技應用程式下載位置：`,
  'landing_page_finditnow': `立即尋找`,
  'landing_page_locate': `定位`,
  'landing_page_locate_description': `隨時隨地尋找您的行動裝置。`,
  'landing_page_lock': `鎖定`,
  'landing_page_lock_description': `阻止任何人使用遺失的行動裝置。`,
  'landing_page_alarm': `警報`,
  'landing_page_alarm_description': `遙控響起警報聲一分鐘。`,
  'landing_page_title': `趨勢科技行動裝置失竊防護入口網站`,
  'landing_page_wipe': `清除`,
  'landing_page_wipe_description': `刪除儲存在您遺失裝置上的所有資料。`,
  'license_day': `天`,
  'license_days': `天`,
  'license_expired': `訂購已到期`,
  'license_vaild_subscription': `訂購有效`,
  'location_not_found': `偵測不到位置。`,
  'map_no_device': `No device protected! To locate a device, install protection now.`,
  'policies_privacy': `法律策略與隱私權`,
  'sign_in': `登入`,
  'sign_out': `登出`,
  'test_temp_locale': `Test`,
  'trendmicrocom': `Trend Micro`,
  'unlock_key': `解除鎖定碼：`,
  'unlock_key_wording': `使用此碼解除鎖定您的行動裝置。`,
  // tmpn success message
  'message_alarm_success': `{0} 正在發出警報聲`,
  'message_locate_success': `重新整理 {0} 的位置`,
  'message_lock_success': `{0} 已鎖定`,
  'message_wipe_success': `已移除 {0} 上的所有資料。`,
  // tmpn POST command error
  "error_alarm": `無法讓 {0} 的警報聲響起`,
  "error_locate": `無法尋找 {0}`, 
  "error_lock": `無法鎖定 {0}`, 
  "error_wipe": `無法清除 {0}`, 
  // tmpn GET command error
  'error_alarm_CS001': `Cannot access your device through the Internet.`,
  'error_alarm_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_locate_CS001': `Cannot access your device through the Internet.`,
  'error_locate_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_locate_CS004': `行動裝置上的 GPS 已關閉，因此無法顯示位置。`,
  'error_lock_CS001': `Cannot access your device through the Internet.`,
  'error_lock_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_wipe_CS001': `Cannot access your device through the Internet.`,
  'error_wipe_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_default': `目前無法執行您的請求`,
  // product name
  'product_name_IS10': `趨勢科技™ 行動安全防護 for iOS`,
  'product_name_IS11': `趨勢科技™ 行動安全防護 for iOS`,
  'product_name_IS12': `趨勢科技™ 行動安全防護 for iOS`,
  'product_name_IS13': `趨勢科技™ 行動安全防護 - 全民版`,
  'product_name_IS14': `iOS 版的安全達人`,
  'product_name_IS27': `Trend Micro™ Mobile Security for iOS`,
  'product_name_ISM0': `行動安全防護-全民版`,
  'product_name_ISM1': `行動安全防護-全民版`,
  'product_name_MS20': `趨勢科技™ 行動安全防護 - 個人版`,
  'product_name_MS21': `ウイルスバスター モバイル for Android™`,
  'product_name_MS23': `趨勢科技™ 行動安全防護 - 個人版`,
  'product_name_MS24': `趨勢科技™ 行動安全防護 - 個人版`,
  'product_name_MS25': `趨勢科技™ 行動安全防護 - 個人版`,
  'product_name_MS26': `趨勢科技™ 行動安全防護 - 個人版`,
  'product_name_MS27': `趨勢科技™ 行動安全防護 - 個人版`,
  'product_name_MS29': `趨勢科技™ 行動裝置定位器`,  
  'product_name_MS30': `趨勢科技™ 行動安全防護 - 個人版`,
  'product_name_MS31': `趨勢科技™ 行動安全防護 - 個人版`,
  'product_name_MS33': `趨勢科技™ 行動安全防護 - 全民版`,
  'product_name_MS34': `Android™ 版的安全達人`,
  'product_name_MS36': `Virus Buster™ Mobile meets Hello Kitty`,
  'product_name_MSM0': `安全達人`,
  'product_name_MSM1': `安全達人`,
};

export default zh_TW;
